var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"max-height":"16","max-width":"16","src":"/img/icons/sefareshhaykasbokar.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }